const CommonContainer = ({ children }) => {
  return (
   <div className="max-w-7xl w-full mx-auto px-4 lg:px-8">
      {children}
    </div>
  );
};

export default CommonContainer;